module.exports = __webpack_public_path__ + "static/media/ic_thumbnail_default2.56fdf895.png";